import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const PendingStdLoans = () => {
    const [StdLoan, setStdLoan] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchStdLoan();
    }, []);

    const fetchStdLoan = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/stdLoans/pending');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setStdLoan(data);
        } catch (error) {
            console.error('Error fetching Student Loans:', error);
        }
    };

    const handleDelete = async (StdLoanId) => { 
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this student loan?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/stdLoans/delete/${StdLoanId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedStdLoans = StdLoan.filter(StdLoan => StdLoan.id !== StdLoanId);
                        setStdLoan(updatedStdLoans);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The student loan has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete student loan');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the student loan.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting student loan:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the student loan.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handleApprove = async (StdLoanId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this student loan?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/stdLoans/approve/${StdLoanId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful approval
                        const updatedStdLoans = StdLoan.filter(StdLoan => StdLoan.id !== StdLoanId);
                        setStdLoan(updatedStdLoans);
                        
                        // Show success message
                        Swal.fire({
                            title: "Approved!",
                            text: "The student loan has been approved.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to approve student loan');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to approve the student loan.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error approving student loan:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to approve the student loan.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter student loans based on search term
    const filteredStdLoans = StdLoan.filter(loan => 
        (loan.degreeName && loan.degreeName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.university && loan.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.institutePhone && loan.institutePhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.instituteEmail && loan.instituteEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.instituteLocation && loan.instituteLocation.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>PENDING STUDENT LOANS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                <th>Degree Name</th>
                                    <th>Institute Name</th>
                                    <th>Start Date</th>
                                    <th>Duration</th>
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>Location</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredStdLoans.map((StdLoan) => (
                                    <tr key={StdLoan.id}>
                                        <td>{StdLoan.degreeName}</td>
                                        <td>{StdLoan.university}</td>
                                        <td>{new Date(StdLoan.startDate).toLocaleDateString('en-CA')}</td>
                                        <td>{StdLoan.duration}</td>
                                        <td>{StdLoan.institutePhone}</td>
                                        <td>{StdLoan.instituteEmail}</td>
                                        <td>{StdLoan.instituteLocation}</td>
                                        <td><a href={StdLoan.link} target="_blank" rel="noopener noreferrer" id='view-website'>Link</a></td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='app-details' onClick={() => handleApprove(StdLoan.id)}>APPROVE</a>
                                            <a href="#!" id='del-details' onClick={() => handleDelete(StdLoan.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingStdLoans;
